import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=mediation&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '',
        pageTitle: '劝和止战',
        pageTitleIcon: '',
        background_img: '',
        description: `华美深度理解业主与经营团队间的摩擦往往源于战略目标错配、权责界定模糊或文化融合障碍等典型问题。华美的劝和止战服务专注于搭建双向沟通桥梁，厘清矛盾根源。华美运用行业基准数据作为客观依据，结合20年实战经验定制调解路径，最终实现股东投资回报与团队执行力的同步提升。`,
        icons: [
            {
                name: '劝和止战',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/14.劝和止战.pdf'),
                path: "四库赋能-酒店资管/劝和止战/劝和止战"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/劝和止战/全球案例/全球案例（劝和止战）.xlsx'),
                path: "四库赋能-酒店资管/劝和止战/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/劝和止战/预警问题/预警问题（劝和止战）.xlsx'),
                path: "四库赋能-酒店资管/劝和止战/预警问题"
            },
            {
                name: '智能工具',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('智能工具'),
                path: "四库赋能-酒店资管/劝和止战/智能工具"
            },
            {
                name: '优选资源',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/劝和止战/优选资源'),
                path: "四库赋能-酒店资管/劝和止战/优选资源"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店资管/劝和止战/华美项目"
            },
        ]
    }]
}